import { DateField } from "react-admin";

/**
 * Campo de leitura para datas civis (nascimento, admissão, efetivo...).
 *
 * Diferente do `DateField` padrão, lê o valor em UTC. Sem isso o navegador
 * converte para o fuso local (UTC-3) e uma data gravada como meia-noite
 * aparece um dia antes — 20/05 exibido como 19/05.
 *
 * Para carimbos de data e hora reais (criação, atualização) continue usando
 * o `DateField` normal: ali a hora local é o que interessa.
 */
export const DateOnlyField = (props: any) => (
  <DateField locales="pt-BR" {...props} options={{ timeZone: "UTC" }} />
);
